<template>
  <div v-if="false" class="p-6 text-4xl font-bold">Não autorizado</div>
  <div class="flex w-full flex-col gap-6 p-6" v-else>
    <div class="flex items-center gap-2">
      <div class="flex flex-col gap-2">
        <label for="busca" class="text-xs"> Filtrar por ativo </label>
        <input
          type="text"
          name="busca"
          id="busca"
          v-model="filter"
          class="bg-ontick-graphite-500 h-10 rounded border-0 text-sm shadow"
          placeholder="Ex.: VALE3"
        />
      </div>
      <div class="flex flex-col gap-2">
        <label for="status" class="text-xs"> Filtrar por status </label>
        <select
          name="status"
          id="status"
          v-model="statusFilter"
          class="bg-ontick-graphite-500 h-10 rounded border-0 text-sm shadow"
        >
          <option value="" selected>Todos</option>
          <option value="ACTIVE">Ativo</option>
          <option value="INACTIVE">Inativo</option>
        </select>
      </div>
    </div>
    <div class="bg-ontick-graphite-500 overflow-auto rounded shadow-lg">
      <table class="w-full">
        <thead>
          <tr>
            <th v-for="th in table_head" :key="th">
              {{ th }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="{ SYMBOL, TOPIC, BID, BID_VOLUME, ASK, ASK_VOLUME, LAST, STATUS } in filteredList"
            :key="SYMBOL"
            :class="{ inactive: STATUS === 'INACTIVE' }"
          >
            <td>
              <span class="text-gray-300">
                {{ SYMBOL }}
              </span>
            </td>
            <td>
              <span>
                {{ TOPIC }}
              </span>
            </td>
            <td>
              <span>
                {{ BID }}
              </span>
            </td>
            <td>
              <span>
                {{ BID_VOLUME }}
              </span>
            </td>
            <td>
              <span>
                {{ ASK }}
              </span>
            </td>
            <td>
              <span>
                {{ ASK_VOLUME }}
              </span>
            </td>
            <td>
              <span>
                {{ LAST }}
              </span>
            </td>
            <td>
              <span :class="statusColor(STATUS)">
                {{ STATUS }}
              </span>
            </td>
            <td>
              <div class="flex items-center justify-center gap-2">
                <button
                  @click="startConsuming(TOPIC)"
                  class="bg-ontick-green-900 flex h-8 w-8 items-center justify-center rounded-full"
                >
                  <i
                    v-html="$icons.loading"
                    class="text-ontick-green-600"
                    v-if="connectionStatus.awaitingConnection"
                  ></i>
                  <i v-html="$icons.play" v-else></i>
                </button>
                <button
                  @click="stopConsuming(TOPIC)"
                  class="bg-ontick-red-900 flex h-8 w-8 items-center justify-center rounded-full"
                >
                  <div class="bg-ontick-red-600 h-2 w-2 rounded-sm"></div>
                </button>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { v4 as uuid } from "uuid";
import EventBus from "../../../../shared/utils/event_bus";
import availableSymbols from "./symbols";
export default {
  data() {
    return {
      // +------------------------------------------------------------------------------------------+
      // | L1   |      BID      |   BID_VOLUME   |      ASK      |    ASK_VOLUME   |      LAST      |
      // +------+---------------+----------------+---------------+-----------------+----------------+
      // | L1   |    43222.12   |      0.15      |    43256.03   |    0.01801639   |    43217.45    |
      // +------------------------------------------------------------------------------------------+
      table_head: ["SYMBOL", "TOPIC", "BID", "BID_VOLUME", "ASK", "ASK_VOLUME", "LAST", "STATUS", "#"],
      table_body: {},
      symbols: [],
      connectionStatus: {
        awaitingConnection: false,
        retries: 0,
        error: false,
      },
      contextUuid: uuid(),
      filter: "",
      statusFilter: "",
    };
  },

  computed: {
    ...mapGetters({
      getConfigs: "config/getConfigs",
      getWebsocketIsConnected: "config/getWebsocketIsConnected",
    }),
    filteredList() {
      const filteredByName = this.filter
        ? this.symbols.filter((item) => item.SYMBOL.toLowerCase().includes(this.filter.toLowerCase()))
        : this.symbols;

      const filteredByStatus = this.statusFilter
        ? filteredByName.filter((item) => item.STATUS === this.statusFilter)
        : filteredByName;

      return filteredByStatus;
    },
    activeTopics() {
      return this.symbols.filter((item) => ["ACTIVE", "WAITING"].includes(item.STATUS)).map((item) => item.TOPIC);
    },
  },

  methods: {
    statusColor(status) {
      switch (status) {
        case "ACTIVE":
          return "text-ontick-green-600";
        case "INACTIVE":
          return "text-ontick-orange-600";
        case "WAITING":
          return "text-ontick-yellow-600";
        default:
          return "text-gray-300";
      }
    },
    setColor(amount) {
      if (amount == 0) return "white";
      if (amount > 0) return "green";
      if (amount < 0) return "red";
    },
    listSymbols() {
      // this.$api
      //   .get(this.$endpoint.LIST_SYMBOLS)
      //   .then((res) => {
      //     this.symbols = res.data.map((symbol) => {
      //       return {
      //         SYMBOL: symbol,
      //         TOPIC: `MD.${symbol}.L1`,
      //         BID: null,
      //         BID_VOLUME: null,
      //         ASK: null,
      //         ASK_VOLUME: null,
      //         LAST: null,
      //         STATUS: null,
      //       };
      //     });
      //   })
      //   .catch((err) => {
      //     console.error(err);
      //   });
      this.symbols = availableSymbols.map((symbol) => {
        return {
          SYMBOL: symbol,
          TOPIC: `MD.${symbol}.L1`,
          BID: null,
          BID_VOLUME: null,
          ASK: null,
          ASK_VOLUME: null,
          LAST: null,
          STATUS: "INACTIVE",
        };
      });
    },
    onMessage({ symbol, data }) {
      let index = this.symbols.findIndex((item) => item.SYMBOL === symbol);
      this.symbols[index].BID = data.bid_price;
      this.symbols[index].BID = data.bid_price;
      this.symbols[index].BID_VOLUME = data.bid_volume;
      this.symbols[index].ASK = data.ask_price;
      this.symbols[index].ASK_VOLUME = data.ask_volume;
      this.symbols[index].LAST = data.last_price;
      this.symbols[index].STATUS = "ACTIVE";
    },
    consume() {
      if (this.connectionStatus.retries > 5) {
        this.connectionStatus.error = true;
        this.connectionStatus.awaitingConnection = false;
        console.error("[ADMIN] Erro ao conectar ao websocket.");
        return;
      }
      if (!this.getWebsocketIsConnected) {
        if (this.isSharedWorker) {
          this.worker.sendMessage({ type: "CHECK_CONNECTION" });
        }
        this.connectionStatus.retries++;
        this.connectionStatus.awaitingConnection = true;
        setTimeout(() => {
          this.consume();
        }, 2000);
        return;
      }
      this.connectionStatus.awaitingConnection = false;
      this.connectionStatus.error = false;
      this.worker.sendMessage({
        type: "CONSUME",
        data: {
          uuid: this.contextUuid,
          topics: this.activeTopics,
          type: "Admin",
        },
      });
      this.worker.sendMessage({
        type: "LOG",
      });
    },
    startConsuming(topic) {
      let index = this.symbols.findIndex((item) => item.TOPIC === topic);
      this.symbols[index].STATUS = "WAITING";
    },
    stopConsuming(topic) {
      let index = this.symbols.findIndex((item) => item.TOPIC === topic);
      this.symbols[index].STATUS = "INACTIVE";
    },
  },

  watch: {
    activeTopics: {
      deep: true,
      handler(val) {
        this.consume();
        // console.log(val);
      },
    },
  },

  mounted() {
    EventBus.$on("MARKET_DATA", (e) => {
      this.onMessage(e);
    });
    this.$api.get(this.$endpoint.LOOKUP).then((res) => console.log(res));
    this.listSymbols();
  },
};
</script>

<style lang="scss" scoped>
table {
  thead {
    @apply bg-ontick-steel-500;
    th {
      @apply py-2 text-xs font-semibold;
    }
  }
  tbody {
    td {
      @apply py-2 text-center text-sm;
    }
  }
}
button {
  @apply filter transition-all ease-in-out hover:brightness-125;
}
.inactive {
  @apply text-gray-500;
}
</style>
